import { createFileRoute } from '@tanstack/react-router';

import { SchainListEditorPage } from '../features/supply/lists/components/SchainListEditorPage/SchainListEditorPage';

export const Route = createFileRoute('/supply/lists_/schain_/create')({
  component: SchainListEditorPage,
});
